<div class="ai-chat-session-rename-dialog">
    <label class="ai-chat-session-rename-dialog__label" for="ai-chat-session-rename-field">
        Название диалога
    </label>
    <input
        id="ai-chat-session-rename-field"
        class="ai-chat-session-rename-dialog__field"
        type="text"
        name="aiChatSessionRenameTitle"
        [(ngModel)]="draftTitle"
        [attr.maxlength]="maxTitleLength"
        autocomplete="off"
        autofocus
    />
</div>
